export default __webpack_public_path__ + "images/comprar-creditos-ico-hover.svg";